import React, { useState, useEffect, useContext } from 'react'
import label from '../../../../../../assets/i18n/en.json'
import toast from "react-hot-toast";
import FormValidatorService from '../../../../../services/validator/form-validator.service';
import { store } from '../../../../../context/StateProvider';
import PatientFinancialHeader from '../../transactions/terminals/virtual-terminal/virtual-terminal-form/PatientFinancialHeader';
import HPTSelect from '../../../../templates/components/HPTSelect';
import { useGetLocationProviderServices } from '../../../../../services/cache/CacheService';
import TreatmentPlanDetailForm from '../treatment-plan-detail/treatment-plan-detail-form/TreatmentPlanDetailForm';
import Table2 from '../../../../templates/components/Table2';
import moment from "moment";
import ProductService from '../../../../../services/api/product.service';
const TreatmentPlanForm = (props) => {
    // Pull properties form parent
    const { isEdit, submitHandler } = props;
    const stateAndDispatch = useContext(store)
    const [formData, setFormData] = useState(props.initialData || {})
    const [errors, setErrors] = useState({})
    const [isLoader, setIsLoader] = useState(true)

    const [doctorList, setDoctorList] = useState()
    const [selectedRow, setSelectedRow] = useState()
    const state = stateAndDispatch.state
    const [showDetail, setShowDetail] = useState(false)
    const stateDoctorList = useGetLocationProviderServices();
    const [locationId, setLocationId] = useState(state.practiceLocationId)
    const [productList, setProductList] = useState([])
    const [detailsList, setDetailsList] = useState([])

    const required = [
        'treatmentPlan',
        'patientId',
        'doctorId'
    ]

    useEffect(() => {
        if (props.patient) {
            inputChange({ target: { name: 'patientId', value: props.patient?.id } })
        }
    }, [props.patient])

    const columns = [
        {
            id: "doctorId",
            Header: "Provider",
            accessor: (row) => {
                let selectedDoctor = doctorList?.find((obj) => obj.id === row.doctorId)
                return selectedDoctor ? (selectedDoctor.firstName + ' ' + selectedDoctor.lastName) : ""
            }
        },
        {
            id: "datePlanned",
            Header: "Date Planned",
            accessor: row => row.datePlanned ? moment(row.datePlanned).format("MM-DD-YYYY") : null,
        }, {
            id: "practiceServiceTypeId",
            Header: "Service",
            accessor: (row) => {
                let selectedProviderService = doctorList?.find((obj) => obj.id === row.doctorId)?.services.find((ser) => ser.practiceServiceTypeId === row.practiceServiceTypeId)?.practiceServiceType
                return selectedProviderService ? selectedProviderService : row.practiceServiceTypeId
            }
        }, {
            id: "itemId",
            Header: "Product",
            accessor: row => {
                let selectedProduct = productList?.find(obj => obj.id === row.itemId)
                return selectedProduct ? selectedProduct.name : row.itemId
            }
        }, {
            id: "quantity",
            Header: "Quantity",
            accessor: row => row.quantity
        }, {
            id: "action",
            Header: "Action",
            disableSortBy: true,
            accessor: (row, i) => {
                return (
                    <div className='btn-group'>
                        <button className="p-0 ps-1 btn btn-primary" title="Edit" onClick={e => { e.preventDefault(); setSelectedRow({ ...row, index: i }); return setShowDetail(true) }}
                            disabled={isLoader}
                            ><i className="icon pencil" /></button>
                        <button className="p-0 ps-1 btn btn-primary" title="Delete" onClick={e => { e.preventDefault(); return removeItems(i) }}><i className="icon trash" /></button>
                    </div>
                )
            }
        }
    ]

    useEffect(() => {
        //reset the value
        setSelectedRow()
    }, [detailsList])

    useEffect(() => {
        if (stateDoctorList) {
            setDoctorList(stateDoctorList)
        }
    }, [stateDoctorList]);
    // formula for input change
    const inputChange = (e) => {
        let newStateObject = { ...formData };
        newStateObject[e.target.name] = e.target.value
        return setFormData(newStateObject);
    };

    useEffect(() => {
        if (props.isEdit) {
            if (props.initialData?.treatmentPlanDetail?.length > 0) {
                setDetailsList(props.initialData?.treatmentPlanDetail)
            }
        }
    }, [])
    useEffect(async () => {
        if(locationId && !props.productList){
          productLookup()
        }else{
            setProductList(props.productList)
            setIsLoader(false)
        }
      }, [locationId]);
    
      const productLookup = () => {
        setIsLoader(true)
        const reqObj = {
          practiceLocationId: locationId,
          includePracticeItems: 'yes',
          isActive: true
        };
        ProductService.productLookup(reqObj)
          .then(res => {
            if (res) {
              setProductList(extractItems(res, 1))
            }
          }).finally(()=>{
            setIsLoader(false)
          })
      }
      const extractItems = (results, itemType) => {
        let items = [];
        if (Array.isArray(results)) {
          items = results.filter(result => { return result?.itemType == itemType && (result?.practiceLocationId == "" || result?.practiceLocationId == locationId) });
        }
        if (!Array.isArray(items)) {
          items = [];
        }
        return items;
      }
    
    const removeItems = (index) => {
        setDetailsList((current) =>
            current.filter((item, i) => i !== index)
        );
    }

    const addDetailList = (localItem) => {
        if (selectedRow) {
            setDetailsList((prevItemList) => prevItemList.map((item, i) => {
                if (i === selectedRow.index) {
                    return localItem;
                }
                return item;
            }));
        } else {
            setDetailsList((prevItemList) => [...prevItemList, localItem]);
        }
        setShowDetail(false)
    }

    return (
        <>
            {props.isLoader && <div className="ui">
                <div className="ui active dimmer">
                    <div className="ui indeterminate text loader">{label.common.processing}</div>
                </div>
            </div>}

            <div className=" fields p-3">
                {!showDetail && <><div className='mb-3'>
                    <PatientFinancialHeader isRenew patient={props.patient} disablePatientEdit={true} />
                </div>
                    <div className="row">
                        <div className="field col-12 required">
                            <label>Treatment Plan</label>
                            <input type="text" name="treatmentPlan" onChange={e => { inputChange(e) }} value={formData?.treatmentPlan} />
                        </div>

                        <div className="field col-12 required">
                            <label>Provider</label>
                            <HPTSelect
                                options={doctorList}
                                className="react-select"
                                classNamePrefix="react-select"
                                onChange={e => {
                                    if (e?.id) {
                                        inputChange({
                                            target:
                                                { value: e.id, name: "doctorId" }
                                        })
                                    }
                                    else {
                                        inputChange({
                                            target:
                                                { value: null, name: 'doctorId' }
                                        })
                                    }
                                }}
                                value={formData.doctorId && doctorList?.find(obj => obj.id === formData.doctorId)}
                                isClearable={true}
                                isLoading={!doctorList}
                                isDisabled={!doctorList}
                                loadingMessage="Retrieving list of providers"
                                placeholder="All Providers"
                                getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                                getOptionValue={(option) => option.id}
                            />
                        </div>
                        <div className="field col-12">
                            <label>Concerns</label>
                            <textarea placeholder="Concerns"
                                className="form-control"
                                value={formData.concerns}
                                onChange={e => { e.preventDefault(); inputChange(e) }}
                                name="concerns"
                                rows={2}
                            ></textarea>
                        </div>
                        <div className="field col-12">
                            <label>Observations</label>
                            <textarea placeholder="Observations"
                                className="form-control"
                                value={formData.observations}
                                onChange={e => { e.preventDefault(); inputChange(e) }}
                                name="observations"
                                rows={2}
                            ></textarea>
                        </div>
                        <div className="field col-12">
                            <label>Home Care</label>
                            <textarea placeholder="Home Care"
                                className="form-control"
                                value={formData.homeCare}
                                onChange={e => { e.preventDefault(); inputChange(e) }}
                                name="homeCare"
                                rows={2}
                            ></textarea>
                        </div>

                    </div></>}
                {formData.doctorId && <div className="row">
                    <div className="field col-12" style={{ marginTop: 15 }}>
                        {showDetail && <button className="btn btn-primary" onClick={(e) => {
                            e.preventDefault();
                            setSelectedRow();
                            setShowDetail(false);
                        }}
                            style={{ marginRight: "5px" }}
                        ><i className="icon angle left"></i>
                        </button>}
                        <span>Treatment Plan Details </span>
                        {!showDetail && <button className="btn btn-primary" onClick={(e) => {
                            e.preventDefault();
                            setShowDetail(true);
                        }}>
                            <i className="icon plus"></i>
                        </button>}
                    </div>
                </div>}
                {showDetail && <TreatmentPlanDetailForm isEdit={selectedRow ? true : false} initialData={selectedRow} doctorList={doctorList} productList={productList} submitHandler={addDetailList} onClose={() => { setSelectedRow(); setShowDetail(false) }} />}
                {!showDetail && <>
                    {detailsList && detailsList.length > 0 && <div style={{ marginTop: "15px" }}><Table2
                        data={detailsList}
                        columns={columns}
                    /></div>}


                    <div className="mt-3 d-flex justify-content-between modal-button-bar">
                        <div className='col-auto'>
                            <button className="btn btn-primary" onClick={e => {
                                e.preventDefault();
                                if (!FormValidatorService.checkForm(errors, formData, required)) {
                                    toast.error("Please make sure the form is complete")
                                }
                                // else if (detailsList.length <= 0) {
                                //     toast.error("Please add at least one item")
                                // }
                                else {
                                    submitHandler(formData, detailsList)
                                }
                            }}>{isEdit ? 'Update' : 'Save'}</button>
                        </div >
                        <div className='col-auto'>
                            {props.onClose && <button className="btn btn-secondary float-right" onClick={e => { e.preventDefault(); props.onClose() }}>Close</button>}
                        </div>
                    </div >
                </>}
            </div >
        </>
    )
}

export default TreatmentPlanForm